import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEscrowTransactionFields extends Layout {
    checkboxIsVoided: Checkbox;
    sourceEscrowTransaction: DataSource;
    textboxAmount: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxEffect: Textbox;
    textboxGlid: Textbox;
    textboxId: Textbox;
    textboxMemo: Textbox;
    textboxPayAdjCode: Textbox;
    textboxPayeeId: Textbox;
}
